import { Navigate, Outlet } from "react-router-dom";
interface ProtectedRouteProps {
  children?: React.ReactNode;
  roles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, roles }) => {
  // get userData from localstorage
  const rawUserData = localStorage.getItem("user_data");
  let userData :any = null;

  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const token = localStorage.getItem("token");

  const parsedUser = userData;
  const isAuthenticated = token && parsedUser;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (roles && parsedUser && !roles.includes(parsedUser?.roles?.role_name)) {
    return <Navigate to="/" replace />;
  }
  
  if (children) return <>{children}</>;

  return <Outlet />;
};

export default ProtectedRoute;
